const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Resolve a stored image URL (relative /api/... or external) to an absolute URL.
export const resolveImg = (url) => {
  if (!url) return '';
  if (url.startsWith('/api/')) return `${BACKEND}${url}`;
  return url;
};

// Lightweight resized WebP version served by the backend, for fast mobile loading.
export const thumbImg = (url, width = 640) => {
  if (!url) return '';
  if (url.startsWith('/api/images/')) return `${BACKEND}${url}?w=${width}`;
  if (url.startsWith('https://')) return `${BACKEND}/api/img?w=${width}&u=${encodeURIComponent(url)}`;
  return resolveImg(url);
};

export default resolveImg;
